import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from 'components/Layout/_shared/Menu/MenuItem';

export default function SubMenuSingle({ items }) {
  return (
    <ul className="sub-menu">
      {items && items.map((item) => <MenuItem key={item.ID} item={item} />)}
    </ul>
  );
}

SubMenuSingle.propTypes = {
  items: PropTypes.array
};
